import notificationService from "src/services/orderNotificationService";

export const SEARCH_NOTIFICATIONS_REQUEST = "@notifications/search-notifications-request";
export const SEARCH_NOTIFICATIONS_SUCCESS = "@notifications/search-notifications-success";
export const SEARCH_NOTIFICATIONS_FAILURE = "@notifications/search-notifications-failure";
export const GET_NOTIFICATIONS_CONTENT_REPLACE_REQUEST =
  "@notifications/get-notifications-content-replace-request";
export const GET_NOTIFICATIONS_CONTENT_REPLACE_SUCCESS =
  "@notifications/get-notifications-content-replace-success";
export const GET_NOTIFICATIONS_CONTENT_REPLACE_FAILURE =
  "@notifications/get-notifications-content-replace-failure";
export const GET_LIST_NOTIFICATION_MESSAGE_REQUEST =
  "@notifications/get-list-notification-message-request";
export const GET_LIST_NOTIFICATION_MESSAGE_SUCCESS =
  "@notifications/get-list-notification-message-success";
export const GET_LIST_NOTIFICATION_MESSAGE_FAILURE =
  "@notifications/get-list-notification-message-failure";
export const GET_ONE_NOTIFICATION_MESSAGE_REQUEST =
  "@notifications/get-one-notification-message-request";
export const GET_ONE_NOTIFICATION_MESSAGE_SUCCESS =
  "@notifications/get-one-notification-message-success";
export const GET_ONE_NOTIFICATION_MESSAGE_FAILURE =
  "@notifications/get-one-notification-message-failure";
export const CLEAR_NOTIFICATION_MESSAGE = "@notifications/clear-notification-message";
export const GET_LIST_NOTIFICATION_HISTORY_MESSAGE_REQUEST =
  "@notifications/get-list-notification-history-message-request";
export const GET_LIST_NOTIFICATION_HISTORY_MESSAGE_SUCCESS =
  "@notifications/get-list-notification-history-message-success";
export const GET_LIST_NOTIFICATION_HISTORY_MESSAGE_FAILURE =
  "@notifications/get-list-notification-history-message-failure";

export function searchNotifications(data = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: SEARCH_NOTIFICATIONS_REQUEST});
      const response = await notificationService.getListNotificationInfos(data);
      dispatch({
        type: SEARCH_NOTIFICATIONS_SUCCESS,
        payload: {
          response: response.data,
          total: parseInt(response.length)
        }
      });
    } catch (error) {
      dispatch({type: SEARCH_NOTIFICATIONS_FAILURE});
      throw error;
    }
  };
}

export function getNotificationContentReplace() {
  return async (dispatch) => {
    try {
      dispatch({type: GET_NOTIFICATIONS_CONTENT_REPLACE_REQUEST});
      const response = await notificationService.getNotificationContentReplace();
      dispatch({
        type: GET_NOTIFICATIONS_CONTENT_REPLACE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_NOTIFICATIONS_CONTENT_REPLACE_FAILURE});
      throw error;
    }
  };
}

// send all notification
export function getListNotificationMessage(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_NOTIFICATION_MESSAGE_REQUEST});
      const response = await notificationService.getListNotificationMessage(params);
      dispatch({
        type: GET_LIST_NOTIFICATION_MESSAGE_SUCCESS,
        payload: {
          response: response.data.data || [],
          total: response?.headers["x-total-items"] || 0
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_NOTIFICATION_MESSAGE_FAILURE});
      throw error;
    }
  };
}

export function getOneNotificationMessage(id) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_ONE_NOTIFICATION_MESSAGE_REQUEST});
      const response = await notificationService.getOneNotificationMessage(id);
      dispatch({
        type: GET_ONE_NOTIFICATION_MESSAGE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: GET_ONE_NOTIFICATION_MESSAGE_FAILURE});
      throw error;
    }
  };
}

export function getListHistoryNotificationMessage(params = {}) {
  return async (dispatch) => {
    try {
      dispatch({type: GET_LIST_NOTIFICATION_HISTORY_MESSAGE_REQUEST});
      const response = await notificationService.getListHistoryNotificationMessage(
        params
      );
      dispatch({
        type: GET_LIST_NOTIFICATION_HISTORY_MESSAGE_SUCCESS,
        payload: {
          response: response.data.data || [],
          total: response?.headers["x-total-items"] || 0
        }
      });
    } catch (error) {
      dispatch({type: GET_LIST_NOTIFICATION_HISTORY_MESSAGE_FAILURE});
      throw error;
    }
  };
}

export function clearNotificationMessage(id) {
  return (dispatch) => {
    dispatch({
      type: CLEAR_NOTIFICATION_MESSAGE
    });
  };
}
